import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { CNPJ, EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, WA_LINK, WA_NUMBER } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="h-3 w-3 bg-krono" aria-hidden="true" />
            <span className="font-display text-2xl font-black tracking-tighter">KRONO</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            Pintura predial em altura via Rope Access. Segurança NR-35, sem andaimes, acabamento premium. Seu prédio merece nascer de novo.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">Contato</p>
          <div className="flex flex-col gap-3">
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-sm text-white/70 transition-colors hover:text-krono">
              <MessageCircle className="h-4 w-4" /> WhatsApp +{WA_NUMBER.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "$1 $2 $3-$4")}
            </a>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 text-sm text-white/70 transition-colors hover:text-krono">
              <Mail className="h-4 w-4" /> {EMAIL}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-sm text-white/70 transition-colors hover:text-krono">
              <Instagram className="h-4 w-4" /> {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">Empresa</p>
          <p className="font-mono text-xs leading-loose text-white/50" data-testid="footer-cnpj">
            KRONO PINTURAS LTDA<br />
            CNPJ {CNPJ}<br />
            São Paulo — SP
          </p>
          <Link
            to="/conteudo"
            data-testid="footer-client-area"
            className="mt-4 inline-block font-mono text-[10px] uppercase tracking-[0.2em] text-white/30 transition-colors hover:text-krono"
          >
            Área do cliente →
          </Link>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-2 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/30 md:flex-row md:justify-between">
        <span>© {new Date().getFullYear()} KRONO — Todos os direitos reservados</span>
        <span>Zona Sul · Oeste · Norte · Leste · Centro · ABC</span>
      </div>
    </div>
  </footer>
);
